import { ShieldCheck, HeartHandshake, Hammer } from "lucide-react";
import { BUSINESS } from "@/data/site";
import { SECTION, BTN_PRIMARY } from "./styles";

const PILLARS = [
  {
    icon: ShieldCheck,
    title: "Veteran-Owned",
    desc: "Discipline, integrity and mission-focus brought to every project.",
  },
  {
    icon: HeartHandshake,
    title: "Family-Oriented",
    desc: "We treat your home the way we would treat our own family's.",
  },
  {
    icon: Hammer,
    title: "Quality Craftsmanship",
    desc: "Attention to detail and workmanship that reflects your vision.",
  },
];

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className={`${SECTION} bg-white`}>
      <div className="grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <p className="font-accent-script text-2xl md:text-3xl text-[#D4AF37] mb-3">
            Where Quality Craftsmanship Meets Your Vision.
          </p>
          <h2
            className="font-serif text-3xl md:text-5xl font-semibold text-[#0A1F3C] gold-underline mb-10"
            data-testid="about-headline"
          >
            WELCOME TO APEX HOME RENOVATION LLC
          </h2>
          <p className="text-[#44506A] leading-relaxed mb-5">
            Established in {BUSINESS.established}, Apex Home Renovation LLC is a veteran-owned,
            family-oriented residential renovation company dedicated to transforming houses into
            beautiful, functional homes.
          </p>
          <p className="text-[#44506A] leading-relaxed mb-5">
            We believe every home deserves exceptional care, attention to detail, and workmanship
            that reflects the homeowner's unique vision. Whether you're updating your flooring,
            refreshing your home's interior, remodeling a living space, or restoring an exterior,
            our team is committed to providing dependable service and professional results.
          </p>
          <p className="font-accent-script text-3xl text-[#D4AF37] mb-10" data-testid="about-motto">
            {BUSINESS.motto}
          </p>
          <a href="#estimate" data-testid="about-request-estimate-btn" className={BTN_PRIMARY}>
            Start Your Project
          </a>
        </div>

        <div className="space-y-6">
          <div className="border border-[#E2E2DE] shadow-sm">
            <img
              src="/assets/project-interior.jpeg"
              alt="Apex interior renovation before and after"
              className="w-full h-64 md:h-80 object-cover object-center"
            />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {PILLARS.map((p) => (
              <div
                key={p.title}
                data-testid={`about-pillar-${p.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="bg-[#F7F7F4] border border-[#E2E2DE] hover:border-[#D4AF37] transition-colors duration-300 p-5"
              >
                <p.icon className="h-6 w-6 text-[#D4AF37] mb-3" />
                <h3 className="font-serif text-lg text-[#0A1F3C] mb-1">{p.title}</h3>
                <p className="text-xs text-[#5A6A85] leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
